import { Carousel, IconButton } from '@chakra-ui/react'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

export default function SimpleCarousel ({ items, itemWidth }) {
  return (
    <Carousel.Root
      slideCount={items.length}
      autoSize
      spacing='8px'
    >
      <Carousel.ItemGroup>
        {items.map((item, index) => (
          <Carousel.Item
            key={index}
            index={index}
            snapAlign='center'
            width='auto'
          >
            {item}
          </Carousel.Item>
        ))}
      </Carousel.ItemGroup>

      <Carousel.Control justifyContent='center' gap='4'>
        <Carousel.PrevTrigger asChild>
          <IconButton size='xs' variant='ghost'>
            <LuChevronLeft />
          </IconButton>
        </Carousel.PrevTrigger>

        <Carousel.Indicators />

        <Carousel.NextTrigger asChild>
          <IconButton size='xs' variant='ghost'>
            <LuChevronRight />
          </IconButton>
        </Carousel.NextTrigger>
      </Carousel.Control>
    </Carousel.Root>
  )
}
